import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "../styles/Experience.css";
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';

function Experience() {
  return (
    <div className="experience" style={{ margin: "2rem 0" }}>

      <VerticalTimeline lineColor="#3e497a">
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="10/2024—Present"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Software Engineer (Team Lead)
          </h3>
          <h4 className="vertical-timeline-element-subtitle" style={{ marginBottom: 0 }}>
            <em>Open Learning Exchange</em>
          </h4>
          <ul>
            <li>Lead software and DevOps for web and mobile platforms</li>
            <li>Apply Agile methods to manage the OLE internship program</li>
            <li>Modernize CI/CD with automated PR creation, reviews, containers, and cloud testing</li>
          </ul>
          <p>TypeScript, Python, Kotlin, Bash, Node.js, Angular, Linux, REST, Docker, CI/CD, Agile</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="08/2023—12/2025"
          iconStyle={{ background: "#002F6C", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            B.S Computer Science (3.9 GPA)
          </h3>
          <h4 className="vertical-timeline-element-subtitle" style={{ marginBottom: 0 }}>
            <em>Towson University</em>
          </h4>
          <p>Specialization in Software Engineering, Data Science, and AI/ML</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="01/2020—Present"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Software & Data Consultant
          </h3>
          <h4 className="vertical-timeline-element-subtitle" style={{ marginBottom: 0 }}>
            <em>Independent Consultant</em>
          </h4>
          <ul>
            <li>Modernize businesses across manufacturing, nonprofit, and retail sectors</li>
            <li>Develop websites using WordPress, React, and custom stacks</li>
            <li>Build backend systems and databases to centralize business data</li>
            <li>Implement CRM workflows using Salesforce, Square, and WP ERP</li>
            <li>Create BI dashboards and reports in Power BI and Tableau</li>
          </ul>
          <p>JavaScript (React, Node.js), Java, C# (ASP.NET), SQL, WordPress, WooCommerce, Power BI, Tableau, CRM (Salesforce, Square, WP ERP)</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="02/2024—08/2025"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Eye-Tracking Data Science Research
          </h3>
          <h4
            className="vertical-timeline-element-subtitle"
            style={{ marginBottom: 0 }}
          >
            <em>Towson University</em>
          </h4>
          <p>Lead developer on a faculty-led study, applying statistical analysis, clustering, sequence modeling, and machine learning to eye-tracking data and co-authoring findings for publication.</p>
          <p>Python (pandas, scikit-learn, numpy), R (arules, tidyverse), Tableau, Excel, Tobii</p>

        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="05/2015—01/2022"
          iconStyle={{ background: "#e9d35b", color: "#fff" }}
          icon={<WorkIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Founder & Chief Operating Officer
          </h3>
          <h4 className="vertical-timeline-element-subtitle" style={{ marginBottom: 0 }}>
            <em>Let’sGrow!</em>
          </h4>
          <ul>
            <li>Managed major consulting engagements and top client accounts</li>
            <li>Built Power BI dashboards and automated analytics workflows</li>
            <li>Developed integrations linking web, CRM, and analytics systems to streamline operations</li>
          </ul>
          <p>Python, JavaScript, Power BI, CRM integration, web development, data analytics</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="08/2019—05/2021"
          iconStyle={{ background: "#002F6C", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            Master of Music (3.9 GPA)
          </h3>
          <h4 className="vertical-timeline-element-subtitle" style={{ marginBottom: 0 }}>
            <em>Johns Hopkins University</em>
          </h4>
          <p>Emphasis on Computer Music, Digital Signal Processing, and Programming</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2010 - 2012"
          iconStyle={{ background: "#002F6C", color: "#fff" }}
          icon={<SchoolIcon />}
        >
          <h3 className="vertical-timeline-element-title">
            A.A. Business Management (3.9 GPA)
          </h3>
          <h4 className="vertical-timeline-element-subtitle" style={{ marginBottom: 0 }}>
            <em>Anne Arundel Community College</em>
          </h4>
          <h5 className="vertical-timeline-element-location" style={{ marginTop: 0 }}>
            Annapolis, MD
          </h5>
        </VerticalTimelineElement>

      </VerticalTimeline>
    </div>
  );
}

export default Experience;
